<template>
  <v-menu bottom left :close-on-content-click="false" v-model="menu">
    <template v-slot:activator="{ on }">
      <v-btn small fab icon v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-action> <v-icon>mdi-cogs</v-icon> </v-list-item-action
          >Itinerary Details Settings
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-item>
          <v-select
            label="Show/Hide"
            multiple
            item-text="label"
            item-value="key"
            :outlined="outlinedInputs"
            :items="allowedTabs"
            v-model="selectedTabs"
            @change="onChange"
          ></v-select>
        </v-list-item>
      </v-list>

      <v-card-actions class="grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn text @click="menu = false" color="warning">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "itinerary-details-settings",

  props: {
    visibleTabs: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      debug: false,
      menu: false,
      tabs: [
        { key: "details", label: "Details" },
        { key: "items", label: "Items" },
        { key: "participants", label: "Participants" },
        { key: "contents", label: "Contents" },
        { key: "documents", label: "Documents" },
        { key: "vouchers", label: "Vouchers" },
        { key: "finances", label: "Finances" },

        { key: "logs", label: "Changelog" },
        { key: "emails", label: "Emails" },
        { key: "customDataTypes", label: "Custom Data" },
      ],
      selectedTabs: this.visibleTabs ? [...this.visibleTabs] : [],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    allowedTabs() {
      const a = [...this.tabs];
      if (this.$store.getters.hasAccessTo("plugins:task_tracker")) {
        a.push({ key: "tasks", label: "Tasks" });
      }
      //console.log(this.$store.getters.hasAccessTo("itineraries:routes", true));
      if (this.$store.getters.hasAccessTo("itineraries:routes", true)) {
        a.push({ key: "routes", label: "Routes" });
      }
      //check access to scenarios
      if (this.$store.getters.hasAccessTo("itineraries:service_groups", true)) {
        a.push({ key: "scenarios", label: "Service Groups" });
      }
      //check access to increments
      if (this.$store.getters.hasAccessTo("itineraries:increments", true)) {
        a.push({ key: "increments", label: "Increments" });
      }
      //check access to push notifications
      if (this.$store.getters.hasAccessTo("itineraries:push_notifications")) {
        a.push({ key: "pushNotifications", label: "Push Notifications" });
      }
      //check access to rooming list
      if (this.$store.getters.hasAccessTo("itineraries:rooming_list")) {
        a.push({ key: "roomingList", label: "Rooming List" });
      }
      return a;
    },
  },

  methods: {
    onChange() {
      this.$emit("change", [...this.selectedTabs]);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetailsSettings.vue